// Política mínima de seguridad para contraseñas de la aplicación.
export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_REQUIREMENTS_TEXT =
  "Mínimo 8 caracteres, con mayúscula, minúscula, número y carácter especial";

const CHECKS = [
  { test: (p) => p.length >= PASSWORD_MIN_LENGTH, label: "Mínimo 8 caracteres" },
  { test: (p) => /[a-z]/.test(p), label: "Una letra minúscula" },
  { test: (p) => /[A-Z]/.test(p), label: "Una letra mayúscula" },
  { test: (p) => /\d/.test(p), label: "Un número" },
  { test: (p) => /[^A-Za-z0-9]/.test(p), label: "Un carácter especial" },
];

const STRENGTH_LEVELS = [
  { max: 2, label: "Débil", color: "#d32f2f" },
  { max: 4, label: "Media", color: "#ed6c02" },
  { max: 5, label: "Fuerte", color: "#2e7d32" },
];

export function evaluatePasswordStrength(password = "") {
  const passedChecks = CHECKS.filter((check) => check.test(password));
  const score = passedChecks.length;
  const isValid = score === CHECKS.length;
  const level = STRENGTH_LEVELS.find((l) => score <= l.max) || STRENGTH_LEVELS[0];
  const missing = CHECKS.filter((check) => !check.test(password)).map((c) => c.label);

  return {
    score,
    total: CHECKS.length,
    percent: (score / CHECKS.length) * 100,
    isValid,
    label: password ? level.label : "",
    color: level.color,
    missing,
  };
}
